import { FC, useState, useMemo, useEffect } from 'react'
import clsx from 'clsx'
import { useBreakpoints } from '@obeta/data/lib/hooks'
import { Modal, ModalCloseIcon } from '../modal/Modal'
import { extractContentGroups } from './helpers'
import { ContentTypeFilterSection } from './components/ContentTypeFilterSection'
import { ContentViewer } from './components/contentViewer/ContentViewer'
import { MediaItemsSection } from './components/mediaItemSection/MediaItemsSection'
import { GalleryModalProps, MediaContentTypes } from './types'
import styles from './GalleryModal.module.scss'

export const GalleryModal: FC<GalleryModalProps> = ({ open, items, selectedIdx, onClose }) => {
  const [activeContentTypeFilter, updateActiveContentTypeFilter] = useState<MediaContentTypes>(
    MediaContentTypes.All
  )

  const { mobile } = useBreakpoints()

  const [activeItemIndex, updateActiveItemIndex] = useState(selectedIdx)

  useEffect(() => {
    updateActiveItemIndex(selectedIdx)
  }, [selectedIdx])

  const { itemsByGroup, totals } = useMemo(() => {
    return extractContentGroups(items)
  }, [items])

  const onSetPreview = (itemIdx: number) => {
    updateActiveItemIndex(itemIdx)
  }

  const updateActiveContentTypeTabHandler = (type: MediaContentTypes) => {
    updateActiveContentTypeFilter(type)

    updateActiveItemIndex(0)
  }

  const activeItemIdxInGroup = itemsByGroup[activeContentTypeFilter].findIndex((item) => {
    return item.itemIndex === activeItemIndex
  })

  const activeItemIdx = activeItemIdxInGroup === -1 ? 0 : activeItemIdxInGroup

  return (
    <Modal
      marginThreshold={'xs'}
      isFullScreen={mobile}
      onClose={onClose}
      open={open}
      keepMounted={false}
      classNames={{ content: styles.modal }}
    >
      <div className={clsx(styles.root, { [styles.rootFullScreen]: mobile })}>
        <ModalCloseIcon onClose={onClose} className={styles.closeBtn} />
        <div className={styles.content}>
          <ContentTypeFilterSection
            totals={totals}
            items={items}
            activeContentTypeFilter={activeContentTypeFilter}
            updateActiveContentTypeFilter={updateActiveContentTypeTabHandler}
          />

          <div className={styles.main}>
            <MediaItemsSection
              activeItemIndex={activeItemIndex}
              activeContentTypeFilter={activeContentTypeFilter}
              onSetPreview={onSetPreview}
              itemsByGroup={itemsByGroup}
            />

            <ContentViewer activeItem={itemsByGroup[activeContentTypeFilter][activeItemIdx]} />
          </div>
        </div>
      </div>
    </Modal>
  )
}
